interface ResumoBarProps {
  saving: boolean;
  canSave: boolean;
  onSave: () => void;
  onNovaCotacao: () => void;
}

export default function ResumoBar({
  saving,
  canSave,
  onSave,
  onNovaCotacao,
}: ResumoBarProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4">
      <div className="flex items-center justify-end gap-3">
          <button
            onClick={onNovaCotacao}
            className="px-4 py-2.5 rounded-lg border border-background-200/70 text-sm font-medium text-foreground-600 hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line mr-1.5" />
            Nova
          </button>

          <button
            onClick={onSave}
            disabled={!canSave || saving}
            className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
              canSave && !saving
                ? 'bg-primary-500 text-white hover:bg-primary-600'
                : 'bg-background-200 text-foreground-400 cursor-not-allowed'
            }`}
          >
            {saving ? (
              <>
                <i className="ri-loader-4-line animate-spin" />
                Salvando...
              </>
            ) : (
              <>
                <i className="ri-save-line" />
                Salvar Cotação
              </>
            )}
          </button>
      </div>
    </div>
  );
}
